export const RDP_CONNECTION_STATE = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    ENABLING: 'enabling',
    DISABLING: 'disabling',
    IPV6NOTSUPPORTED: 'ipv6notsupported'
}